import { objectifyError } from './utils';
export class BaseError extends Error {
  constructor(message) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }

}
export class ResourceNotFoundError extends BaseError {
  constructor(...args) {
    super(...args);
    this.name = 'ResourceNotFoundError';
  }

}
export class ParameterError extends BaseError {
  constructor(...args) {
    super(...args);
    this.name = 'ParameterError';
  }

}
export class ApiError extends BaseError {
  constructor(...args) {
    super(...args);
    this.name = 'ApiError';
  }

}
export class UnexpectedError extends BaseError {
  constructor(message, swallowed) {
    super(message);
    this.name = 'UnexpectedError';
    this.swallowed = void 0;

    if (swallowed) {
      this.swallowed = objectifyError(swallowed);
    }
  }

}